export const SERVICE_CODE = 'TRAINING_SPECIALITIES' + '_SERVICE';
